import { isMarketingAllowed } from './consent';

export function setGa4UserId(userId: string | null) {
  // A rejected consent or GPC visitor gets cookieless pings, which must not carry an identifier.
  if (userId && !isMarketingAllowed()) return;
  try {
    window.gtag?.('set', { user_id: userId });
  } catch {
    // A blocked tag must not interrupt login or logout.
  }
}

export const clearGa4UserId = () => setGa4UserId(null);
